(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2905],{

/***/ 25011:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(2258);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 7202:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 2258:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(7202);
} else {}


/***/ }),

/***/ 70533:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gift-vouchers",
      function () {
        return __webpack_require__(3085);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useFetch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43692);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44453);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83244);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44743);
/* harmony import */ var _apiHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65639);
/* harmony import */ var _firebase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54087);
/* harmony import */ var enums_errors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10367);







function fetcher(url, locale) {
    return _fetcher.apply(this, arguments);
}
function _fetcher() {
    _fetcher = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, locale) {
        var queryParams, ref, ref1, idToken, headers, _args = arguments;
        return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryParams = _args.length > 2 && _args[2] !== void 0 ? _args[2] : {};
                    ;
                    _ctx.next = 4;
                    return (ref = _firebase__WEBPACK_IMPORTED_MODULE_4__/* .firebaseApp */ .H === null || _firebase__WEBPACK_IMPORTED_MODULE_4__/* .firebaseApp */ .H === void 0 ? void 0 : _firebase__WEBPACK_IMPORTED_MODULE_4__/* .firebaseApp.auth */ .H.auth()) === null || ref === void 0 ? void 0 : (ref1 = ref.currentUser) === null || ref1 === void 0 ? void 0 : ref1.getIdToken();
                case 4:
                    idToken = _ctx.sent;
                    headers = {
                        "Content-Type": "application/json",
                        "Accept-Language": locale
                    };
                    if (idToken) {
                        headers["Authorization"] = "Bearer ".concat(idToken);
                    }
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default()("".concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_3__/* .baseApiUrl */ .td)()).concat(url).concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_3__/* .queryStringFromObject */ .jR)(queryParams)), {
                            method: "GET",
                            headers: headers
                        }).then(function(res) {
                            if (res.status === 204) {
                                resolve({});
                            } else if (res.status > 204) {
                                switch(res.status){
                                    case 402:
                                        reject(enums_errors__WEBPACK_IMPORTED_MODULE_5__/* .AppApiError.PaymentNeeded */ .u.PaymentNeeded);
                                        break;
                                    default:
                                        res.json().then(reject);
                                }
                            } else {
                                resolve(res.json());
                            }
                        }).catch(reject);
                    }));
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetcher.apply(this, arguments);
}
// hooks use on client side
function useFetch(path, locale) {
    var canLoad = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, queryParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (!path) {
        throw new Error("Path is required");
    }
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(canLoad ? path : null, function() {
        return fetcher(path, locale, queryParams);
    }, {
        revalidateOnMount: true,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshWhenOffline: false,
        refreshWhenHidden: false,
        refreshInterval: 0
    }), data = ref.data, error = ref.error, isValidating = ref.isValidating, mutate = ref.mutate;
    return {
        data: data,
        error: error,
        isValidating: isValidating,
        mutate: mutate
    };
}


/***/ }),

/***/ 21779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56168);
/* harmony import */ var react_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85429);
/* harmony import */ var _context_stripeContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16096);





var CardInput = function(param) {
    var className = param.className, _disable = param.disable, disable = _disable === void 0 ? false : _disable;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().t;
    var ref = (0,_context_stripeContext__WEBPACK_IMPORTED_MODULE_4__/* .useStripeCtx */ .o)(), stripeCard = ref.stripeCard, stripeError = ref.stripeError, setElementsLoaded = ref.setElementsLoaded, enableCardInput = ref.enableCardInput, disableCardInput = ref.disableCardInput;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setElementsLoaded(true);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        disable && disableCardInput();
        !disable && enableCardInput();
    }, [
        disable
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "stripe-card-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                className: "info-ico card-info-ico",
                "data-tip": true,
                "data-for": "cardInput",
                onClick: function(e) {
                    return e.stopPropagation();
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: className !== null && className !== void 0 ? className : "",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "info-label",
                        children: t("common:form.payment_card")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        id: "cardInput",
                        place: "top",
                        effect: "solid",
                        className: "dramox-tooltip",
                        isCapture: true,
                        children: t("common:form.card_tooltip")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: stripeCard,
                        className: "stripe-card"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        ref: stripeError
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardInput);


/***/ }),

/***/ 17194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56168);
/* harmony import */ var _api_useFetch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45509);
/* harmony import */ var _context_authContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13102);
/* harmony import */ var _enums_buyType__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10129);
/* harmony import */ var _CardInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21779);
/* harmony import */ var _LoadingComponent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63104);
/* harmony import */ var _Select_Select__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53173);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12701);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_9__);











var Cards = function(param) {
    var setSelected = param.setSelected, selected = param.selected, showCountrySelect = param.showCountrySelect;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().t;
    var ref = (0,_context_authContext__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)(), user = ref.user, isUserLoaded = ref.isUserLoaded, isAnonymous = ref.isAnonymous, locale = ref.locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), countryOptions = ref1[0], setCountryOptions = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), preselectedCountry = ref2[0], setPreselectedCountry = ref2[1];
    var ref3 = (0,_api_useFetch__WEBPACK_IMPORTED_MODULE_3__/* .useFetch */ .i)("/user/cards", locale, !!user), cards = ref3.data, isValidating = ref3.isValidating;
    var ref4 = (0,_api_useFetch__WEBPACK_IMPORTED_MODULE_3__/* .useFetch */ .i)("countries", locale, isUserLoaded && showCountrySelect), countries = ref4.data;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ((cards === null || cards === void 0 ? void 0 : cards.length) > 0) {
            var ref;
            var defaulCard = (ref = cards.find(function(card) {
                return card.is_default;
            })) !== null && ref !== void 0 ? ref : cards[0];
            setSelected(defaulCard.id);
        }
    }, [
        cards
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (countries) {
            var ref;
            setCountryOptions(countries === null || countries === void 0 ? void 0 : countries.map(function(c) {
                return {
                    value: c.id,
                    label: c.title
                };
            }));
            setPreselectedCountry((ref = countries.find(function(c) {
                return c.suggested;
            })) === null || ref === void 0 ? void 0 : ref.id);
        }
    }, [
        countries
    ]);
    var loading = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LoadingComponent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {});
    if (!isUserLoaded || isValidating) {
        return loading;
    }
    if (isAnonymous && isUserLoaded) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                    className: [
                        "email",
                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardLabel)
                    ].join(" "),
                    children: [
                        t("common:card_email"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            type: "text",
                            id: "email",
                            name: "email"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                    ]
                }),
                showCountrySelect && !!countryOptions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                    className: [
                        "email",
                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardLabel)
                    ].join(" "),
                    children: [
                        t("common:country"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_Select__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            options: countryOptions,
                            defaultLabel: t("common:pick_country"),
                            name: "taxCountry",
                            defaultValue: preselectedCountry
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            ]
        });
    }
    var getLabeledCards = function() {
        return cards.map(function(card) {
            return {
                label: "".concat(card.brand[0].toUpperCase() + card.brand.slice(1), " **** ").concat(card.last_four_digits),
                value: card.id
            };
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: cards && cards.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardLabel),
                    children: [
                        t("common:saved_cards"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_Select__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            defaultLabel: t("common:saved_cards_placeholder"),
                            name: "card",
                            defaultValue: cards[0].id,
                            onChange: setSelected,
                            options: getLabeledCards().concat({
                                label: t("common:add_new_card"),
                                value: _enums_buyType__WEBPACK_IMPORTED_MODULE_5__/* .CardType.NewCard */ .e.NewCard
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                    ]
                }),
                selected === _enums_buyType__WEBPACK_IMPORTED_MODULE_5__/* .CardType.NewCard */ .e.NewCard ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}) : null
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Cards);


/***/ }),

/***/ 17383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62044);


var StripeDisclaimer = function(param) {
    var className = param.className;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
        className: "stripe-disclaimer ".concat(className !== null && className !== void 0 ? className : ""),
        children: [
            t("common:form.payment_secured_with"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                target: "_blank",
                rel: "external",
                href: "https://stripe.com/",
                title: "stripe",
                children: "stripe"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StripeDisclaimer);


/***/ }),

/***/ 3085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ gift_vouchers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(43692);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(44453);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1984);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75332);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./enums/index.ts + 3 modules
var enums = __webpack_require__(39933);
// EXTERNAL MODULE: ./helpers/jsx.tsx
var jsx = __webpack_require__(28808);
// EXTERNAL MODULE: ./context/index.ts + 2 modules
var context = __webpack_require__(52662);
// EXTERNAL MODULE: ./api/client.ts
var client = __webpack_require__(66564);
// EXTERNAL MODULE: ./components/Cards/index.tsx
var Cards = __webpack_require__(17194);
// EXTERNAL MODULE: ./components/Layout/index.tsx + 12 modules
var Layout = __webpack_require__(46323);
// EXTERNAL MODULE: ./context/authContext.tsx + 3 modules
var authContext = __webpack_require__(13102);
// EXTERNAL MODULE: ./context/stripeContext.tsx + 1 modules
var stripeContext = __webpack_require__(16096);
// EXTERNAL MODULE: ./helpers/index.ts + 50 modules
var helpers = __webpack_require__(17651);
// EXTERNAL MODULE: ./pages/gift-vouchers/index.module.scss
var index_module = __webpack_require__(28406);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./helpers/Analytics.ts
var Analytics = __webpack_require__(86639);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(50744);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./context/langContext.ts
var langContext = __webpack_require__(70082);
// EXTERNAL MODULE: ./components/StripeDisclaimer/index.tsx
var StripeDisclaimer = __webpack_require__(17383);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(50862);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha-enterprise/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* eslint-disable prettier/prettier */



var ReCAPTCHA = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.enterprise.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.enterprise.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.enterprise.reset(this._widgetId);
    }
  };

  _proto.forceReset = function forceReset() {
    if (this.props.grecaptcha) {
      this.props.grecaptcha.enterprise.reset();
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    // eslint-disable-next-line prettier/prettier
    if (this.props.grecaptcha && this.props.grecaptcha.enterprise && this.props.grecaptcha.enterprise.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.enterprise.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge,
        isolated: this.props.isolated
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        isolated = _this$props.isolated,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl", "isolated"]);
    /* eslint-enable no-unused-vars */


    return /*#__PURE__*/react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"]),
  isolated: (prop_types_default()).bool
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(25011);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha-enterprise/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/enterprise.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha-enterprise/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);

// EXTERNAL MODULE: ./enums/country.ts
var country = __webpack_require__(72473);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(46834);
;// CONCATENATED MODULE: ./pages/gift-vouchers/index.tsx



// @ts-ignore





















var BuyVoucher = function(param) {
    var plans = param.plans, countryCode = param.countryCode;
    var formRef = (0,react.useRef)(null);
    var t = (0,useTranslation/* default */.Z)(enums/* Namespace.Vouchers */.lS.Vouchers).t;
    var createNotification = (0,context/* useNotificationContext */.nw)().createNotification;
    var ref = (0,react.useState)(""), selectedCard = ref[0], setSelectedCard = ref[1];
    var ref1 = (0,react.useState)(), recaptchaError = ref1[0], setRecaptchaError = ref1[1];
    var ref2 = (0,react.useState)(undefined), recaptchaToken = ref2[0], setRecaptchaToken = ref2[1];
    var refMailto = (0,react.useRef)();
    console.log(plans);
    var ref3 = (0,authContext/* useAuth */.aC)(), user = ref3.user, isUserLoaded = ref3.isUserLoaded;
    var router = (0,next_router.useRouter)();
    var locale = (0,langContext/* useLang */.J)().locale;
    var ref4 = (0,stripeContext/* useStripeCtx */.o)(), createPaymentMethod = ref4.createPaymentMethod, cardHasError = ref4.cardHasError, confirmCardPayment = ref4.confirmCardPayment, stripeCard = ref4.stripeCard, stripeError = ref4.stripeError;
    var RULE_NOT_EMPTY = t("common:form.not_empty");
    var RULE_EMAIL = t("common:form.email_format");
    var setServerError = (0,react.useCallback)(function(msg) {
        stripeCard.current.classList.add("error");
        stripeError.current.innerHTML = msg;
    }, [
        stripeCard,
        stripeError
    ]);
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var form, planId, plan, voucherBuySuccessCallback, voucherBuyFailedCallback, ref, ref1, formSchema, email, taxCountry, validateObject, valid, payment, res, confirmResp, payMethod, respPay, res1, confirmResp1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        form = event.target;
                        planId = parseInt(form.plan.value);
                        plan = plans.find(function(p) {
                            return p.id === planId;
                        });
                        voucherBuySuccessCallback = function() {
                            createNotification({
                                title: t("buy_success")
                            });
                            Analytics/* default.v2_voucherPurchase */.ZP.v2_voucherPurchase(plan);
                            router.push(helpers/* Permalink.root */.xm.root(null, locale, "seznam_cId=".concat(Analytics/* SEZNAM_CID_SUCCESS_VOUCHER */.yO)));
                        };
                        voucherBuyFailedCallback = function() {
                            createNotification({
                                title: t("buy_fail")
                            });
                            (0,helpers/* resetForm */.Fx)(formRef.current);
                        };
                        if (user) {
                            _ctx.next = 45;
                            break;
                        }
                        ;
                        formSchema = (0,helpers/* createFormSchema */.ZS)({
                            email: (0,helpers/* emailRule */.$D)(RULE_EMAIL, RULE_NOT_EMPTY),
                            taxCountry: (0,helpers/* notEmptyRule */.ji)(RULE_NOT_EMPTY)
                        });
                        email = (ref = form.email) === null || ref === void 0 ? void 0 : ref.value;
                        taxCountry = (ref1 = form.taxCountry) === null || ref1 === void 0 ? void 0 : ref1.value;
                        validateObject = {
                            email: email,
                            taxCountry: taxCountry
                        };
                        if (!recaptchaToken) {
                            setRecaptchaError(t("common:form.recaptcha_error_not_checked"));
                        }
                        valid = (0,helpers/* validateForm */.G$)(formSchema, validateObject, formRef.current) && recaptchaToken;
                        if (!(valid && !cardHasError)) {
                            _ctx.next = 42;
                            break;
                        }
                        _ctx.next = 18;
                        return createPaymentMethod();
                    case 18:
                        payment = _ctx.sent;
                        if (!payment.error) {
                            _ctx.next = 23;
                            break;
                        }
                        {
                            (0,helpers/* resetForm */.Fx)(formRef.current);
                            setServerError(payment.error.message);
                        }
                        _ctx.next = 40;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.next = 26;
                        return (0,client/* getSharedApiClient */.L)().paymentVoucher({
                            email: email,
                            payment_method: payment.paymentMethod.id,
                            plan_id: planId,
                            currency: plan.price.currency,
                            tax_country: +taxCountry,
                            g_recaptcha: recaptchaToken
                        });
                    case 26:
                        res = _ctx.sent;
                        if (!(res.status === "ACTION_REQUIRED")) {
                            _ctx.next = 34;
                            break;
                        }
                        _ctx.next = 30;
                        return confirmCardPayment(res.payment_intent_client_secret, null, payment.paymentMethod.id);
                    case 30:
                        confirmResp = _ctx.sent;
                        if (confirmResp.error) {
                            setServerError(confirmResp.error.message);
                            (0,helpers/* resetForm */.Fx)(formRef.current);
                        } else {
                            voucherBuySuccessCallback();
                        }
                        _ctx.next = 35;
                        break;
                    case 34:
                        if (res.status === "SUCCEEDED") {
                            voucherBuySuccessCallback();
                        } else {
                            voucherBuyFailedCallback();
                        }
                    case 35:
                        _ctx.next = 40;
                        break;
                    case 37:
                        _ctx.prev = 37;
                        _ctx.t0 = _ctx["catch"](23);
                        voucherBuyFailedCallback();
                    case 40:
                        _ctx.next = 43;
                        break;
                    case 42:
                        {
                            (0,helpers/* resetForm */.Fx)(formRef.current);
                        }
                    case 43:
                        _ctx.next = 73;
                        break;
                    case 45:
                        (0,helpers/* setLoadingState */.bG)(formRef.current);
                        ;
                        if (!(selectedCard !== enums/* CardType.NewCard */.eT.NewCard && selectedCard !== "")) {
                            _ctx.next = 51;
                            break;
                        }
                        {
                            // user choose saved card, try pay with it
                            payMethod = selectedCard;
                        }
                        _ctx.next = 56;
                        break;
                    case 51:
                        if (cardHasError) {
                            _ctx.next = 56;
                            break;
                        }
                        _ctx.next = 54;
                        return createPaymentMethod();
                    case 54:
                        respPay = _ctx.sent;
                        if (respPay.error) {
                            setServerError(respPay.error.message);
                            (0,helpers/* resetForm */.Fx)(formRef.current);
                        } else {
                            payMethod = respPay.paymentMethod.id;
                        }
                    case 56:
                        _ctx.prev = 56;
                        _ctx.next = 59;
                        return (0,client/* getSharedApiClient */.L)().paymentVoucher({
                            payment_method: payMethod,
                            currency: plan.price.currency,
                            plan_id: planId
                        });
                    case 59:
                        res1 = _ctx.sent;
                        if (!(res1.status === "ACTION_REQUIRED")) {
                            _ctx.next = 67;
                            break;
                        }
                        _ctx.next = 63;
                        return confirmCardPayment(res1.payment_intent_client_secret, null, payMethod);
                    case 63:
                        confirmResp1 = _ctx.sent;
                        if (confirmResp1.error) {
                            setServerError(confirmResp1.error.message);
                            (0,helpers/* resetForm */.Fx)(formRef.current);
                        } else {
                            voucherBuySuccessCallback();
                        }
                        _ctx.next = 68;
                        break;
                    case 67:
                        {
                            voucherBuySuccessCallback();
                        }
                    case 68:
                        _ctx.next = 73;
                        break;
                    case 70:
                        _ctx.prev = 70;
                        _ctx.t1 = _ctx["catch"](56);
                        voucherBuyFailedCallback();
                    case 73:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    23,
                    37
                ],
                [
                    56,
                    70
                ]
            ]);
        }));
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        formRef,
        cardHasError,
        selectedCard,
        confirmCardPayment,
        createPaymentMethod,
        stripeCard,
        stripeError,
        recaptchaError,
        recaptchaToken, 
    ]);
    (0,react.useEffect)(function() {
        if (recaptchaToken) {
            setRecaptchaError("");
        }
    }, [
        recaptchaToken
    ]);
    (0,react.useEffect)(function() {
        if (refMailto.current) {
            refMailto.current.href = "mailto:".concat(refMailto.current.text);
        }
    }, [
        refMailto
    ]);
    var onRecaptchaError = (0,react.useCallback)(function() {
        setRecaptchaError(t("common:form.recaptcha_error_global"));
    }, []);
    var onRecaptchaExpired = (0,react.useCallback)(function() {
        setRecaptchaError(t("common:form.recaptcha_error_expired"));
        setRecaptchaToken(undefined);
    }, []);
    var isCountryCzechia = (0,react.useMemo)(function() {
        return isUserLoaded && countryCode === country/* Country.Czechia */.c.Czechia;
    }, [
        isUserLoaded,
        user,
        countryCode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: (0,jsx/* basicSEO */.F)(t("seo:vouchers_buy_title"), t("seo:vouchers_buy_description"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: (index_module_default()).vouchers,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (index_module_default()).donateWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: t("title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("description")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            ref: formRef,
                            onSubmit: onSubmit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("radios", (index_module_default()).radios),
                                    children: plans === null || plans === void 0 ? void 0 : plans.map(function(plan) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "radio",
                                                    defaultChecked: plan.recurrence.length === 1 && plan.recurrence.unit === "MONTH",
                                                    name: "plan",
                                                    value: plan.id,
                                                    id: "".concat(plan.id)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                                    className: classnames_default()("radio", (index_module_default()).radio),
                                                    htmlFor: "".concat(plan.id),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                            children: plan.alias
                                                        }),
                                                        t("vouchers:price_with_vat", {
                                                            price: plan.price.formatted
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, plan.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards/* default */.Z, {
                                    selected: selectedCard,
                                    setSelected: setSelectedCard,
                                    showCountrySelect: true
                                }),
                                isUserLoaded && !user && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (index_module_default()).recaptcha,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm, {
                                            sitekey: "6Le9WKwgAAAAAFumMvr0xEXi9dYjKNqXldIRI1ux",
                                            onChange: setRecaptchaToken,
                                            onErrored: onRecaptchaError,
                                            onExpired: onRecaptchaExpired,
                                            hl: locale
                                        }),
                                        recaptchaError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "standalone-error",
                                            children: recaptchaError
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn-primary",
                                    children: t("buy_btn")
                                }),
                                isCountryCzechia && /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeDisclaimer/* default */.Z, {}),
                                isCountryCzechia && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (index_module_default()).divider,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("common:or")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            rel: "external",
                                            target: "_blank",
                                            href: "https://www.online.dramox.cz/product-page/dramox-d%C3%A1rkov%C3%BD-voucher",
                                            className: "btn btn-warning",
                                            children: t("buy_physical_voucher")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "companies",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                                        i18nKey: "vouchers:for_companies",
                                        components: {
                                            contactMail: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#",
                                                ref: refMailto
                                            })
                                        }
                                    })
                                })
                            ]
                        }),
                        isCountryCzechia && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (index_module_default()).givery,
                            target: "_blank",
                            href: "https://www.givery.cz/dramox/",
                            children: t("givery")
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var gift_vouchers = ((0,stripeContext/* ProvideStripe */.U)(BuyVoucher));


/***/ }),

/***/ 12701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardLabel":"Cards_cardLabel__l0VA0","cardIcon":"Cards_cardIcon__nBYYK"};

/***/ }),

/***/ 28406:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"vouchers":"gift-vouchers_vouchers__8RECv","donateWrapper":"gift-vouchers_donateWrapper__DFp0_","givery":"gift-vouchers_givery__loeIQ","radios":"gift-vouchers_radios__yujBR","radio":"gift-vouchers_radio__DLwUw","btn":"gift-vouchers_btn__ZONCl","companies":"gift-vouchers_companies__1_3Aw","recaptcha":"gift-vouchers_recaptcha__pGqgp","divider":"gift-vouchers_divider__WV0q5"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4743,5429,9774,2888,179], function() { return __webpack_exec__(70533); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);